







    import Vue from 'Vue';
    import Vuex from 'Vuex';
    import contentControl from './contentControl.vue'

    export default Vue.extend({
        name: 'application-controls',
        components: {
            'content-control': contentControl
        }
    });
